var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"title-wrap"},[_c('v-col',{staticClass:"icon-title word-type pb-5",attrs:{"cols":"12"}},[_c('icon-celebration',{attrs:{"width":24,"height":24}}),_vm._v("신규입사자")],1)],1),_c('new-member-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }